//
import { mapActions, mapState } from 'vuex'
import { RForm } from '@/components/reusable_components/next'
import TranslatorService from '@/services/translator'

//
import StockAdjustModel from '@/models/Warehouse/WhStockAdjust'
import fields from './fields'
import { cloneDeep } from 'lodash'

//
export default {
    name: 'stock-adjust-update',
    components: {
        RForm,
    },
    computed: {
        //
        ...mapState('AuthModule', {
            user: 'user',
        }),

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        authorizeProps() {
            return {
                fields: [
                    {
                        name: 'confirm_description',
                        type: 'textarea',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            label: 'Comentario',
                        },
                    },
                ],
            }
        },

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        rejectProps() {
            return {
                fields: [
                    {
                        name: 'confirm_description',
                        type: 'textarea',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            label: 'Comentario',
                        },
                    },
                ],
            }
        },

        fieldsProps() {
            return this.formData.wh_warehouse_id
                //g_branch_office_id: this.user.hr_employee.g_branch_office_id,
                
        },

        /**
         *
         */
        formProps() {
            return {
                editable: false,
                fields: fields(this.fieldsProps).map(f => {
                    if (this.formData.is_confirmed && f.props)
                        f.props.readonly = true
                    return f
                }),
                loading: this.busy,
            }
        },
    },
    data() {
        return {
            busy: false,
            dialog: {
                authorize: false,
                reject: false,
            },
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        //
        ...mapActions('SnackbarModalModule', [
            'setErrorSnackbar',
            'setSuccessSnackbar',
            'setWarningSnackbar',
        ]),

        /**
         * { function_description }
         */
        authorize() {
            return this.toWait(true)
                .then(this.toAuthorize)
                .then(this.toWait)
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  error   The error
         * @return     {<type>}  { description_of_the_return_value }
         */
        error(error) {
            return this.setErrorSnackbar(
                TranslatorService(StockAdjustModel, error.response.data)
            )
        },

        /**
         * { function_description }
         */
        reject() {
            return this.toWait(true)
                .then(this.toReject)
                .then(this.toWait)
        },

        /**
         *
         */
        fetch() {
            StockAdjustModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        reset() {
            this.fetch()
            this.busy = true
            this.dialog.authorize = false
            this.dialog.reject = false
        },

        /**
         *
         */
        setFormData(model) {
            this.busy = false
            this.formData = model.clone().reset()
        },

        /**
         * { function_description }
         */
        submitAuthorize() {
            this.dialog.authorize = true
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  model   The model
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitConfirm() {
            return this.dialog.authorize ? this.authorize() : this.reject()
        },

        /**
         * { function_description }
         */
        submitReject() {
            this.dialog.reject = true
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        successAuthorize() {
            return this.setSuccessSnackbar(
                'Ajuste de stock autorizado exitosamente.'
            )
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        successReject() {
            return this.setSuccessSnackbar(
                'Ajuste de stock rechazado exitosamente.'
            )
        },

        /**
         * Returns an authorize representation of the object.
         *
         * @return     {<type>}  Authorize representation of the object.
         */
        toAuthorize(model) {
            return model
                .authorize()
                .attach(model.toAuthorize())
                .then(this.successAuthorize)
                .then(this.reset)
                .catch(this.error)
        },

        /**
         * Returns a reject representation of the object.
         *
         * @return     {<type>}  Reject representation of the object.
         */
        toReject(model) {
            return model
                .reject()
                .attach(model.toReject())
                .then(this.successReject)
                .then(this.reset)
                .catch(this.error)
        },

        /**
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         */
        toWait(value = false) {
            return this.dialog.authorize
                ? this.$refs.authorize.setWait(value)
                : this.$refs.reject.setWait(value)
        },
        submitEdit() {
            let data = cloneDeep(this.formData)
            data.details = data.wh_selected_products
            if (!data.confirm_description) data.confirm_description = '-'
            new StockAdjustModel(data)
                .save()
                .then(() =>
                    this.showSnackbar(
                        'success',
                        'Éxito',
                        'Ajuste de stock editado exitosamente'
                    )
                )
                .catch(e => {
                    this.showSnackbar(
                        'error',
                        'Error',
                        e &&
                        e.response &&
                        e.response.data &&
                        e.response.data.message
                            ? e.response.data.message
                            : e || 'Ha ocurrido un error'
                    )
                })
        },
        showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
    },
    beforeMount() {
        this.setTitleTopBar('Datos de ajuste de stock')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_STOCK_ADJUST')) ctx.$router.push('/')
        })
    },
}
